import CloseIcon from "@mui/icons-material/CloseRounded";
import { Box, IconButton, Tooltip } from "@mui/material";
import type { MouseEvent } from "react";

interface Props {
  blockedMessage?: string;
  onDelete: () => void;
}

const CardDeleteButton = ({ blockedMessage, onDelete }: Props) => {
  const handleClick = (event: MouseEvent) => {
    event.stopPropagation();
    onDelete();
  };

  return (
    <Tooltip title={blockedMessage ?? "Delete"}>
      <Box component="span">
        <IconButton color="error" disabled={blockedMessage !== undefined} onClick={handleClick}>
          <CloseIcon />
        </IconButton>
      </Box>
    </Tooltip>
  );
};

export default CardDeleteButton;
